export default function (http) {
    return {
        queryPage (data){
            return http.json({
                url: '/card/apply/record/query',
                data
            });
        },
        queryAudit (data){
            return http.json({
                url: '/card/apply/record/audit',
                data
            });
        },
        exportExcel(data){
            return http.json({
                url: '/card/apply/export',
                data
            });

        },

        delete (data){
            return http.json({
                url: '/card/apply/record/delete',
                data
            });
        },

        save (data){
            return http.json({
                url: '/card/apply/record/save',
                data
            });
        },

        pass (data){
            return http.json({
                url: '/card/apply/record/pass',
                data
            });
        },
        exportXnkExcel (data){
            return http.json({
                url: '/card/info/queryAll',
                data
            });
        },
        fail (data){
            return http.json({
                url: '/card/apply/record/fail',
                data
            });
        },

        queryOperateGrantInfo (data){
            return new Promise()
        },

        queryBindDevicePage (data){
            return http.json({
                url: '/sys/org/device/query',
                data
            });
        },

        removeDeviceBind (data){
            return http.json({
                url: 'sys/org/device/delete',
                data
            });
        },

        queryDeviceBindInfo (data){
            return http.json({
                url: '/sys/org/device/getOne',
                data
            });
        },

        saveDeviceBindInfo (data){
            return http.json({
                url: '/sys/org/device/save',
                data
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/cardApplyRecord.js